import React, { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import classnames from 'classnames';

import { usePrevious } from '@lib/hooks';

import { useStyles } from 'components/TelehealthSessionLink/TelehealthSessionLink.useStyles';
import { TextField } from 'components/v2';

import messages from './messages';

interface TelehealthProps {
  classes: any;
  copied?: boolean;
  label: string;
  onCopy: () => void;
  url: string;
}

const TelehealthSessionLink: React.FC<TelehealthProps> = ({ classes, copied, label, onCopy, url }) => {
  const [copiedLink, setCopiedLink] = useState(false);
  const prevCopied = usePrevious(copied);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (copied !== prevCopied) {
      setCopiedLink(Boolean(copied));
    }
  }, [copied, prevCopied]);

  const handleCopy = () => {
    setCopiedLink(true);

    if (onCopy) {
      onCopy();
    }
  };

  return (
    <div className={classes.root}>
      <Typography color="primary" className={classnames(classes.text, classes.label)} component="div">
        {label}
      </Typography>
      <TextField color="primary" className={classes.link} value={url} />
      <CopyToClipboard onCopy={handleCopy} text={url}>
        <Typography color="primary" className={classes.copyWrapper} component="div">
          <span className={classnames(classes.text, classes.button)}>
            {copiedLink ? formatMessage(messages.copied) : formatMessage(messages.copy)}
          </span>
          {copiedLink && <CheckIcon className={classes.icon} />}
        </Typography>
      </CopyToClipboard>
    </div>
  );
};

export default withStyles(useStyles)(TelehealthSessionLink);
